 
import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { deleteScheduledMaintenance } from '../../actions/actionType/schedule-maintenance/DeleteScheduledMaintenanceTypes';
import {
  deleteScheduledMaintenanceFailure,
  deleteScheduledMaintenanceStart,
  deleteScheduledMaintenanceSuccessful
} from '../../actions/sagaActions/schedule-maintenance/DeleteScheduledMaintenanceSagaActions';
import {
  DeleteScheduledMaintenanceFailurePayload,
  DeleteScheduledMaintenanceRequest
} from '../../actions/types/schedule-maintenance/DeleteScheduledMaintenanceTypes';

/**
 * Call Delete metric summary by API
 * @returns api response
 */

interface IData {
  maintenanceName: string;
}

export async function callDeleteScheduledMaintenanceApi(
  data: IData
) {
  return apiWrapper.delete(`${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/schedule-maintenance/${data.maintenanceName}`);
}

export function* deleteScheduledMaintenanceApi({
  requestObject
}: DeleteScheduledMaintenanceRequest) {
  // yield put(cleardeleteScheduledMaintenance());
  yield put(deleteScheduledMaintenanceStart());
  try {
    const { responseBody: data, isError, error } = yield call(
      callDeleteScheduledMaintenanceApi,
      requestObject
    );
    if (isError) {
      throw error;
    }
    if (!data) {
      yield put(deleteScheduledMaintenanceSuccessful(data));
    } else {
      throw new Error('No Response');
    }
  } catch (error: any) {
    const obj: DeleteScheduledMaintenanceFailurePayload = {
      error: 'Unable to delete Scheduled Maintenance Service'
    };
    yield put(deleteScheduledMaintenanceFailure(obj));
  }
}
/**
 * Saga Effect to consider latest request
 */
export function* DeleteScheduledMaintenanceSaga() {
  yield takeLatest(
    deleteScheduledMaintenance.DELETE_SCHEDULED_MAINTENANCE_REQUEST,
    deleteScheduledMaintenanceApi
  );
}

export const deleteScheduledMaintenanceSaga = [
  fork(DeleteScheduledMaintenanceSaga)
];
